import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { cn } from '../../lib/cn';

import { BlockedAccountBanner } from '../../features/auth/BlockedAccountBanner';
import { BottomNav } from './BottomNav';
import { RouteFallback } from './RouteFallback';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

/**
 * Player-facing shell: bottom tab bar on phones, persistent sidebar from `lg`.
 * Content is capped at a readable width and padded at the bottom so the tab bar
 * never covers the last card.
 */
/** Wide tables would scroll sideways at the readable width used elsewhere. */
const WIDE_PATHS = new Set(['/predictions', '/balance']);

export function AppShell() {
  const { pathname } = useLocation();
  const wide = WIDE_PATHS.has(pathname);

  return (
    <div className="flex min-h-dvh min-w-0 overflow-x-clip bg-canvas">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:rounded-control focus:bg-brand focus:px-4 focus:py-2 focus:font-semibold focus:text-brand-ink"
      >
        Перейти к содержимому
      </a>

      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />
        <main
          id="main"
          className={cn(
            'mx-auto w-full min-w-0 flex-1 overflow-x-clip px-4 pt-5 pb-28 sm:px-6 lg:px-8 lg:pt-7 lg:pb-10',
            wide ? 'max-w-7xl' : 'max-w-4xl',
          )}
        >
          <BlockedAccountBanner />
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </main>
      </div>

      <BottomNav />
    </div>
  );
}
